import isSafari from '@/utilities/isSafari';

export default function useIsEditable() {
  const isEditable = (event: Event) => {
    if (isSafari()) {
      if ((event.target as HTMLElement | null)?.isContentEditable) {
        return;
      }
      event.preventDefault();
    }
  };

  return { isEditable };
}
